<div class="iti-container" [ngClass]="{ 'even-background': !(index % 2) }">
    <div class="iti-absolute" [ngClass]="{ 'even-background': !(index % 2) }">
        <fa-icon [icon]="iconOfiti"></fa-icon>
    </div>
    <div class="iti-border">
        <p class="iti-program-name">
            {{ chainItem?.name }}
        </p>
        <p>
            <small class="iti-small">
                {{ chainItem?.city }}, {{ chainItem?.state }} |
                {{ chainItem?.type }}
            </small>
        </p>
        <p class="iti-text">
            {{ chainItem?.startdate | date: 'longDate':'UTC' }} -
            {{ chainItem?.enddate | date: 'longDate':'UTC' }}
        </p>
        <p class="iti-text">${{ chainItem?.price }} USD</p>
        <ion-row>
            <ion-col size="6">
                <div class="next-container">
                    <span class="iti-label">Next Step:</span>
                    <ion-text
                        fill="clear"
                        color="secondary"
                        class="iti-next-btn"
                        (click)="applicationRouting(chainItem)"
                    >
                        <span>
                            {{ chainItem | futureStatus }}
                        </span>
                    </ion-text>
                </div>
            </ion-col>
            <ion-col size="6" class="iti-last-col ion-text-left">
                <ion-button
                    (click)="cancelApplication(chainItem)"
                    fill="clear"
                    *ngIf="
                        chainItem?.states === 'Pending' ||
                        chainItem?.states === 'Accepted'
                    "
                    shape="round"
                    class="iti-remove"
                >
                    Cancel
                </ion-button>
            </ion-col>
        </ion-row>
    </div>
</div>
